import { render } from "./Matricula.vue?vue&type=template&id=0cd41c72"
import script from "./Matricula.vue?vue&type=script&lang=js"
export * from "./Matricula.vue?vue&type=script&lang=js"

import "./Matricula.vue?vue&type=style&index=0&id=0cd41c72&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__